let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kVX56"), load("ijWsV")]).then(() => parcelRequire('k9PUn'));